<!--subtitle 副标操作项-->
<!--panelBody 看板主体内容-->
<!--示例参照 src/views/modules/statistics/shop-wide-analysis/modules/comprehensive-analysis.vue-->

<template>
  <div class="gj-analysis-panel">
<!--    <gj-separator :height="10"/>-->
    <div>
      <el-row type="flex" align="middle" class="gj-analysis-row">
        <div :class="['left-option-header', leftShadow ? 'left-shadow' : '']">
          <div class="left-option-header-title">{{ title }}<slot name="subtitle"></slot></div>
        </div>
        <div class="rightContainer">
          <slot name="rightContainer"></slot>
        </div>
      </el-row>
    </div>
    <div class="panel-container">
      <slot name="panelBody"></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: "gj-analysis-panel",
  components: {},
  props: {
    leftShadow: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    numDays:{
      type: String,
      default: '2021-01-12~2021-01-18 | 近 7 天'
    },
  }
}
</script>

<style lang="scss" scoped>
.gj-analysis-panel{
  width: 100%;
  height: 100%;
  border-radius: 6px;
  background: white;

  .panel-container{
    width: 100%;
    height: 100%;
    padding-right: 12px;
    box-sizing: border-box;
  }
}
.gj-analysis-row{
  width: 100%;
  justify-content: space-between;
  //border-bottom: 1px solid #EEEEEE;
  padding: 0 16px;
  box-sizing: border-box;
  border-radius: 6px 6px 0px 0px;
}
.left-option-header-title{
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.left-option-header-select{

}
.left-option-header-time{
  display: inline-block;
  margin-left: 10px;
  font-size: 12px;
  color: #888;
  font-weight: 500;
}
.left-option-header {
  background: #fff;
  margin-top: 14px;
  float: left;
}
.left-shadow {
  /*box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);*/
}
.panel-container{

}
.rightContainer{
  float: right;
}
</style>